/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero Friction`)
};

const zh_hans1_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`零摩擦体验`)
};

const zh_hant1_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`零摩擦體驗`)
};

const fr_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zéro friction`)
};

const de_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Null Reibung`)
};

const ja_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手間ゼロ`)
};

const ko_card_seamless_integration_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마찰 제로`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_seamless_integration_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_seamless_integration_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_seamless_integration_title", locale)
	if (locale === "en") return en_card_seamless_integration_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_seamless_integration_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_seamless_integration_title(inputs)
	if (locale === "fr") return fr_card_seamless_integration_title(inputs)
	if (locale === "de") return de_card_seamless_integration_title(inputs)
	if (locale === "ja") return ja_card_seamless_integration_title(inputs)
	return ko_card_seamless_integration_title(inputs)
};